import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  base_url = environment.baseUrl;
  private isAuthenticated = false;
  private token: string;
  private authStatusListener = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) { }

  /**
   * Login API call
   * @param loginData
   */

  login(loginData: any): any {
    // console.log(loginData);
    return this.httpClient.post(this.base_url + 'auth/login', loginData);
  }


  // to get token
  getToken(): any {
    return localStorage.getItem('token');
  }

  // To get user is Authenticated or not
  getIsAuth(): any {
    // console.log(localStorage.getItem('token'))
    if(localStorage.getItem('token')){
      return true;
    }else{
      return false;
    }

  }


  sessionBuilder(loginData: any) {

    this.token = loginData.token;
    this.isAuthenticated = true;
    this.authStatusListener.next(true);

    // to make the auto log out functionality after a certain time
    const now = new Date();
    const expirationDate = new Date(now.getTime() + 1000 * 10000);
    console.log(expirationDate);

    localStorage.setItem('user', JSON.stringify(loginData.user));
    localStorage.setItem('token', this.token);
    localStorage.setItem('expiration', expirationDate.toISOString());

    sessionStorage.setItem('token', this.token);
    this.router.navigate(['projects']);
    // if(loginData.user.role === 'dataentry'){
    //   this.router.navigate(['dashboard/leads']);
    // }else if(loginData.user.role === 'sales'){
    //   this.router.navigate(['dashboard/leads/manage']);
    // }else{
    //   this.router.navigate(['projects']);
    // }
  }

  // to logout a user
  logout(): void {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    localStorage.clear();
    this.router.navigate(['/']);
  }



}
